module.exports = __webpack_public_path__ + "static/image/history/m/202106@3x.ver2_0_2.jpg?336cb937";